import { useState } from 'react';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedRowToDelete, setSelectedRowToDelete] = useState(null);
  const [selectedRowToConfirm, setSelectedRowToConfirm] = useState(null);
  const [isBusinessGrantPermissionOpen, setIsBusinessGrantPermissionOpen] = useState(false);
  const [currentWallet, setCurrentWallet] = useState({});
  const [currentGuild, setCurrentGuild] = useState({});
  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [cameFromGuilds, setCameFromGuilds] = useState(false);
  const [account, setAccount] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const [dialogData, setDialogData] = useState(null);

  return {
    loading,
    setLoading,
    actionLoading,
    setActionLoading,
    isConfirmOpen,
    setIsConfirmOpen,
    selectedRowToDelete,
    setSelectedRowToDelete,
    filterParams,
    size,
    cameFromGuilds,
    setCameFromGuilds,
    setSize,
    page, setPage,
    setFilterParams,
    selectedRowToConfirm,
    setSelectedRowToConfirm,
    isBusinessGrantPermissionOpen,
    setIsBusinessGrantPermissionOpen,
    currentWallet,
    setCurrentWallet,
    currentGuild,
    setCurrentGuild,
    account,
    setAccount,
    selectedRow, setSelectedRow,
    dialogData, setDialogData
  };
};

export default useCustomHook;
